import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home/Home.vue";
import Login from "../views/login/Login.vue";
import TemplateDesigner from "../views/templates/TemplateDesigner.vue";
import PlayableSchedules from "../views/scheduleAdmin/PlayableSchedules.vue";
import CreateSchedule from "../views/scheduleAdmin/CreateSchedule.vue";
import LottoProducts from "../views/products/LottoProducts.vue";
import BingoProducts from "../views/products/BingoProducts.vue";
import FOBProducts from "../views/products/FOBProducts.vue";
import Templates from "../views/templates/Templates.vue";
import Schedules from "../views/scheduleAdmin/Schedules.vue";
import CallerScreen from "../views/game/CallerScreen.vue";
import LottoCallerScreen from "../views/game/LottoCallerScreen.vue";
import FixedOddsBingoCallerScreen from "../views/game/FixedOddsBingoCallerScreen.vue";
import VerifySchedule from "../views/scheduleAdmin/VerifySchedule.vue";
import PlayerScreen from "../views/game/PlayerScreen.vue";
import FixedOddBingoPlayerScreen from "../views/game/FixedOddBingoPlayerScreen.vue";
import LottoPlayerScreen from "../views/game/LottoPlayerScreen.vue";
import PhysicalBooks from "../views/physical/PhysicalBooks.vue";
import Reporting from "../views/reporting/Reporting.vue";
import Books from "../views/books/Books.vue";
import Sales from "../views/sales/Sales.vue";
import store from "@/store";
import Scanner from "../views/scanner/Scanner.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      needLogin: true,
      hideBackButton: true,
      backRoute: null,
    },
  },
  {
    path: "/scanner",
    name: "Scanner",
    component: Scanner,
    meta: {
      needLogin: true,
      hideBackButton: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      needLogin: false,
      hideBackButton: true,
      backRoute: null,
    },
  },
  {
    path: "/template/designer",
    name: "Template Designer",
    component: TemplateDesigner,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: "/templates",
    },
  },
  {
    path: "/templates",
    name: "Templates",
    component: Templates,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: "/",
    },
  },
  {
    path: "/sales/:scheduleId",
    name: "Sales",
    component: Sales,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: "/scheduler",
    },
  },
  {
    path: "/scheduler",
    name: "Schedules",
    component: Schedules,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: "/",
    },
  },
  {
    path: "/schedules",
    name: "PlayableSchedules",
    component: PlayableSchedules,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: "/",
    },
  },
  {
    path: "/start/:scheduleId",
    name: "Caller",
    component: VerifySchedule,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: "/scheduler",
    },
  },

  {
    path: "/play/game/fixed_odds_bingo",
    name: "Game",
    component: FixedOddsBingoCallerScreen,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: () => {
        const scheduleId = localStorage.getItem("lastScheduleId");
        return `/start/${scheduleId}`;
      },
    },
  },
  {
    path: "/play/game/lotto",
    name: "Game",
    component: LottoCallerScreen,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: "/scheduler",
    },
  },
  {
    path: "/play/game/bingo",
    name: "Game",
    component: CallerScreen,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: "/scheduler",
    },
  },
  {
    path: "/scheduler/create",
    name: "Create Scheduler",
    component: CreateSchedule,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: "/scheduler",
    },
  },
  {
    path: "/products/fixed_odds_bingo/:scheduleId",
    name: "FOBProducts",
    component: FOBProducts,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: "/scheduler",
    },
  },
  {
    path: "/products/bingo/:scheduleId",
    name: "BingoProducts",
    component: BingoProducts,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: "/scheduler",
    },
  },
  {
    path: "/products/lotto/:scheduleId",
    name: "LottoProducts",
    component: LottoProducts,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: "/scheduler",
    },
  },
  {
    path: "/reporting",
    name: "Reporting",
    component: Reporting,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: "/",
    },
  },
  {
    path: "/play/game/view/:scheduleId",
    name: "View Game",
    component: PlayerScreen,
    meta: {
      needLogin: false,
      hideAppBar: true,
      hideBackButton: true,
      backRoute: null,
    },
  },
  {
    path: "/play/game/viewFixedOddBingo/:scheduleId",
    name: "View Fixed Odds Bingo Game",
    component: FixedOddBingoPlayerScreen,
    meta: {
      needLogin: false,
      hideAppBar: true,
      hideBackButton: true,
      backRoute: null,
    },
  },
  {
    path: "/play/game/viewlotto/:scheduleId",
    name: "View Lotto Game",
    component: LottoPlayerScreen,
    meta: {
      needLogin: false,
      hideAppBar: true,
      hideBackButton: true,
      backRoute: null,
    },
  },
  {
    path: "/products/physical",
    name: "Physical",
    component: PhysicalBooks,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: "/",
    },
  },
  {
    path: "/books",
    name: "Books",
    component: Books,
    meta: {
      needLogin: true,
      hideBackButton: false,
      backRoute: "/",
    },
  },
  {
    path: "/admin",
    name: "Admin",
    component: () =>
      import(/* webpackChunkName: "admin" */ "../views/systemAdmin/Admin.vue"),
    meta: {
      needLogin: true,
      hideAppBar: true,
      hideBackButton: false,
      backRoute: "/",
    },
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  let proceed = true;
  if (to.meta.needLogin && !store.getters.getToken) {
    proceed = false;
  }

  if (from.name) {
    router.app.$store?.commit("setPreviousRoute", from.path);
  }

  if (to.params.scheduleId) {
    localStorage.setItem("lastScheduleId", to.params.scheduleId);
  }

  proceed ? next() : next("/login");
});

router.goBack = function() {
  if (store.getters.getSecond) {
    store.dispatch("updateSecond", false);
    return;
  }
  const currentRoute = this.currentRoute;

  if (currentRoute.name === "Schedules") {
    this.push("/");
    return;
  }

  if (currentRoute.meta.backRoute) {
    const backRoute =
      typeof currentRoute.meta.backRoute === "function"
        ? currentRoute.meta.backRoute()
        : currentRoute.meta.backRoute;

    this.push(backRoute);
    return;
  }

  this.go(-1);
};

export default router;
